<template lang="pug">
  .notifications
    v-container.pa-0(style="max-width:600px")
      v-tabs.mt-2(v-model="selectedTab" fixed-tabs color="textColorAccent" height="40")
        v-tab.button-AA-medium(v-for="t in tabItems" :key="t.id") {{ t.text }}
      v-layout.my-6(v-if="!isFetching && notifications.length === 0")
        v-row.fill-height.ma-0(align='center' justify='center')
          div.mx-auto
            v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
            p.caption {{ $t('no_notification') }}
      .items-layout(v-else)
        .list-item.my-2
          v-list.pt-0(three-line dense)
            template(v-for="(n, index) in notifications")
              notification-item(:item="n" :key="n.id" @onMarkRead="handleMarkRead" @onDelete="handleDelete" @viewDetails="viewDetails($event)")
              v-divider.basic300(v-if="index !== notifications.length - 1")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(indeterminate color="primary" :width="2" :size="50")
          v-card.white(height="1px" v-intersect="infiniteScrolling")

    y-dialog(fill-height fluid v-model="showDetails" :fullscreen="$vuetify.breakpoint.xsOnly" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.h6.basic800--text(style="height:56px;") {{ detailItem.title }}
        v-card-text(v-html="detailItem.body")
        v-divider
        v-card-actions
          v-spacer
          v-btn(color='grey', text @click="closeDetails") {{ $t('close') }}
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import NotificationItem from '@/components/NotificationItem'

export default {
  name: 'Notifications',
  components: { NotificationItem },
  data: () => ({
    showHeader: true,
    lastScrollPosition: 0,
    isFetching: false,
    tabItems: [
      {id: 'default', text: 'Yezza'},
      {id: 'transaction_paid', text: 'Sales'},
      {id: 'lead_created', text: 'Leads'}
    ],
    selectedTab: 0,
    detailItem: {},
    showDetails: false,
    notifications: [],
    hasNext: true,
    page: 1
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({
      company: 'getCompany'
    })
  },
  watch: {
    selectedTab () {
      this.notifications = []
      this.page = 1
      this.hasNext = true
      this.fetchNext()
    }
  },
  mounted () {
    this.fetchNext()
    if (this.$route.query.id) {
      this.fetchDetails(this.$route.query.id)
    }
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition < 0) {
        return
      }
      this.showHeader = currentScrollPosition <= this.lastScrollPosition
      this.lastScrollPosition = currentScrollPosition
    },
    infiniteScrolling (entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.fetchNext()
      }
    },
    fetchNext () {
      if (this.isFetching || !this.hasNext) {
        return
      }
      this.isFetching = true
      let params =  {
        type: this.tabItems[this.selectedTab].id,
        page: this.page,
        member: this.member.id
      }
      this.$axios.get('/notifications/', { params }).then(resp => {
        this.notifications = this.notifications.concat(resp.data.results)
        this.hasNext = resp.data.next !== null
        this.page++
      }).finally(() => {
        this.isFetching = false
      })
    },
    fetchDetails (itemId) {
      let params =  {
        member: this.member.id
      }
      this.$axios.get(`/notifications/${itemId}/`, { params }).then(resp => {
        this.viewDetails(resp.data)
      })
    },
    viewDetails (item) {
      this.detailItem = item
      this.showDetails = true
    },
    closeDetails () {
      this.showDetails = false
      this.$router.replace({ query: {}})
    },
    handleMarkRead (itemId) {
      this.$set(this.notifications.filter(n => n.id === itemId)[0], 'read', true)
      this.$axios.patch(`/notifications/${itemId}/?member=${this.member.id}`, { read: true })
    },
    handleDelete (itemId) {
      this.$delete(this.notifications, this.notifications.findIndex(n => n.id === itemId))
      this.$axios.delete(`/notifications/${itemId}/?member=${this.member.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card__text, .v-card__title {
  word-break: normal;
}
</style>

<i18n>
{
  "en": {
    "Yezza": "Yezza",
    "Sales": "Sales",
    "Lead": "Lead",
    "no_notification" : "You have no notification"

  },
  "id": {
    "Yezza": "Yezza",
    "Sales": "Jualan",
    "Lead": "Lead",
    "no_notification" : "Tiada notifikasi"

  }
}
</i18n>